import { render, staticRenderFns } from "./LookupInput.vue?vue&type=template&id=53e601e2&"
import script from "./LookupInput.vue?vue&type=script&lang=js&"
export * from "./LookupInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../shared/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports